import { useLang } from "../i18n";

const INK = "27,25,23";
const CORAL = "#8E2118";

// layout on a 1200x520 viewBox
const TOKYO = [372, 252];
const TORONTO = [828, 252];

const TOKYO_SATS = [
  { n: "SENDAI", x: 452, y: 148, cx: 428, cy: 190 },
  { n: "TOHOKU", x: 442, y: 198, cx: 420, cy: 222 },
  { n: "OSAKA", x: 438, y: 302, cx: 418, cy: 282 },
  { n: "HYŌGO", x: 452, y: 352, cx: 428, cy: 312 },
];

const TORONTO_SATS = [
  { n: "LONDON", x: 748, y: 148, cx: 772, cy: 190 },
  { n: "OTTAWA", x: 762, y: 196, cx: 782, cy: 220 },
  { n: "KINGSTON", x: 758, y: 306, cx: 780, cy: 284 },
  { n: "STRATFORD", x: 744, y: 352, cx: 770, cy: 314 },
];

const labelStyle = {
  fontFamily: "'IBM Plex Mono', monospace",
  fontSize: 11,
  letterSpacing: "0.28em",
  fill: `rgba(${INK},0.55)`,
};

const hubLabelStyle = {
  fontFamily: "'IBM Plex Mono', monospace",
  fontSize: 15,
  letterSpacing: "0.3em",
  fill: `rgba(${INK},0.9)`,
};

export const BridgeDiagram = () => {
  const { lang } = useLang();
  return (
    <section data-testid="bridge-diagram" className="relative bg-cream overflow-hidden border-b border-sand">
      <span
        aria-hidden="true"
        data-testid="diagram-watermark"
        className="pointer-events-none select-none absolute inset-0 flex items-center justify-center font-serif leading-none whitespace-nowrap text-navy/[0.055] text-[34vw] lg:text-[24rem]"
      >
        {lang === "jp" ? "架け橋" : "BRIDGE"}
      </span>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 py-16 sm:py-24">
        <svg viewBox="0 0 1200 520" className="w-full h-auto" role="img" aria-label="Tokyo to Toronto network diagram">
          {/* faint flat circle */}
          <circle cx="600" cy="260" r="235" fill="none" stroke={`rgba(${INK},0.09)`} strokeWidth="1" />

          {/* hub connectors */}
          {TOKYO_SATS.map((s) => (
            <path key={s.n} d={`M ${TOKYO[0]} ${TOKYO[1]} Q ${s.cx} ${s.cy} ${s.x} ${s.y}`} fill="none" stroke={`rgba(${INK},0.3)`} strokeWidth="0.75" />
          ))}
          {TORONTO_SATS.map((s) => (
            <path key={s.n} d={`M ${TORONTO[0]} ${TORONTO[1]} Q ${s.cx} ${s.cy} ${s.x} ${s.y}`} fill="none" stroke={`rgba(${INK},0.3)`} strokeWidth="0.75" />
          ))}

          {/* main line + coral diamond */}
          <line x1={TOKYO[0]} y1={TOKYO[1]} x2={TORONTO[0]} y2={TORONTO[1]} stroke={`rgba(${INK},0.45)`} strokeWidth="1" />
          <rect x="593" y="245" width="14" height="14" transform="rotate(45 600 252)" fill={CORAL} />

          {/* hubs */}
          <circle cx={TOKYO[0]} cy={TOKYO[1]} r="2.6" fill={`rgba(${INK},0.9)`} />
          <circle cx={TORONTO[0]} cy={TORONTO[1]} r="2.6" fill={`rgba(${INK},0.9)`} />
          <text x="350" y="257" textAnchor="end" style={hubLabelStyle}>TOKYO</text>
          <text x="850" y="257" textAnchor="start" style={hubLabelStyle}>TORONTO</text>

          {/* satellites */}
          {TOKYO_SATS.map((s) => (
            <g key={`t-${s.n}`}>
              <circle cx={s.x} cy={s.y} r="1.8" fill={`rgba(${INK},0.8)`} />
              <text x={s.x - 10} y={s.y + 4} textAnchor="end" style={labelStyle}>{s.n}</text>
            </g>
          ))}
          {TORONTO_SATS.map((s) => (
            <g key={`c-${s.n}`}>
              <circle cx={s.x} cy={s.y} r="1.8" fill={`rgba(${INK},0.8)`} />
              <text x={s.x + 10} y={s.y + 4} textAnchor="start" style={labelStyle}>{s.n}</text>
            </g>
          ))}
        </svg>
      </div>
    </section>
  );
};
